<template>
  <div>
    <project-toolbar :selectMonth="true" :selectProject="false" />
    <md-content v-if="commitments && !isEmpty">
      <md-card class="card">
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30">
              <md-field>
                <label>{{ L('commitmentType') }}</label>
                <md-select
                  v-model="commitmentType"
                  @md-selected="selectedType()"
                >
                  <md-option
                    v-for="type in types"
                    :key="type.type"
                    :value="type.type"
                    >{{ type.check ? `${type.type} *` : type.type }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-30">
              <md-field>
                <label>{{ L('region') }}</label>
                <md-select
                  v-model="region"
                  multiple
                  @md-selected="selectedType('region')"
                >
                  <md-button
                    class="md-dense md-raised"
                    @click="selectedAll('region')"
                  >
                    {{ L('allRegions') }}
                  </md-button>
                  <md-option
                    v-for="region in regions"
                    :key="region"
                    :value="region"
                    >{{ region }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-30">
              <md-field>
                <label>{{ L('project') }}</label>
                <md-select
                  v-model="project"
                  multiple
                  @md-selected="selectedType('project')"
                >
                  <md-button
                    class="md-dense md-raised"
                    @click="selectedAll('project')"
                  >
                    {{ L('allProjects') }}
                  </md-button>
                  <md-option
                    v-for="project in projects"
                    :key="project.id"
                    :value="project.id"
                  >
                    {{ project.id == '' ? `(${L('account')})` : project.name }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-10">
              <md-button class="md-primary md-raised" @click="getCommitments()">
                {{ L('load') }}
              </md-button>
            </div>
          </div>

          <div v-if="commitments && commitments.length && commitments">
            <div class="title">
              {{ `${curMonth} ${L('title')}` }}
            </div>

            <div class="box">
              <div class="box-item">
                <div class="strong">{{ L('region') }}</div>
                <div class="sub-item">
                  {{ activeRegions }}
                </div>
              </div>
              <div class="box-item">
                <div class="strong">{{ L('activeCommitments') }}</div>
                <div class="sub-item">
                  {{
                    activeCommitment ? `${activeCommitment}${unit}` : L('none')
                  }}
                </div>
              </div>
              <div class="box-item">
                <div class="strong">{{ L('commitmentUtilization') }}</div>
                <div class="sub-item">
                  <div
                    @mouseover="hover = true"
                    @mouseleave="hover = false"
                    style="width: 100px; margin: 0 auto"
                  >
                    {{
                      percentage(
                        averageUsages.active_commitment,
                        averageUsages.utilized_commitment
                      )
                    }}
                    <md-icon>info</md-icon>
                  </div>
                </div>
                <div v-if="hover" class="hover-tooltip">
                  <div class="tooltip-item">
                    <h3>{{ curMonth }}</h3>
                    <div class="tooltip-content">
                      <div class="tooltip-sub-title">
                        {{ L('commitmentDesc') }}({{
                          L('averagePerMicrosecond')
                        }})
                      </div>
                      <div class="tooltip-commitment" style="margin-top: 15px">
                        <div style="display: flex">
                          <hr class="tooltip-line" />
                          <div>{{ L('activeCommitment') }}</div>
                        </div>
                        <div>
                          {{ `${averageUsages.active_commitment}${unit}` }}
                        </div>
                      </div>
                      <div class="tooltip-commitment">
                        <div>{{ L('utilizedCommitment') }}</div>
                        <div>
                          {{ `${averageUsages.utilized_commitment}${unit}` }}
                        </div>
                      </div>
                      <div class="tooltip-commitment">
                        <div>{{ L('unUtilizedCommitment') }}</div>
                        <div>
                          {{ `${averageUsages.unutilized_commitment}${unit}` }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <GChart
                type="ComboChart"
                :data="chartData"
                :options="chartOptions"
              />
            </div>

            <div class="table">
              <md-table md-thin md-stripe>
                <md-table-row>
                  <md-table-head>{{ L('usage') }}</md-table-head>
                  <md-table-head>{{
                    L('averagePerMicrosecond')
                  }}</md-table-head>
                  <md-table-head>{{ L('highlights') }}</md-table-head>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>{{ L('allUsage') }}</md-table-cell>
                  <md-table-cell>{{
                    `${averageUsages.all_usage}${unit}`
                  }}</md-table-cell>
                  <md-table-cell></md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>
                    <div style="display: flex">
                      <div
                        class="tooltip-box"
                        style="background-color: #3366cc"
                      ></div>
                      {{ L('commitmentUsage') }}
                    </div>
                  </md-table-cell>
                  <md-table-cell>{{
                    `${averageUsages.utilized_commitment}${unit}`
                  }}</md-table-cell>
                  <md-table-cell>{{
                    percentage(
                      averageUsages.all_usage,
                      averageUsages.utilized_commitment
                    )
                  }}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell>
                    <div style="display: flex">
                      <div
                        class="tooltip-box"
                        style="background-color: #bdbdbd"
                      ></div>
                      {{ L('ondemandUsage') }}
                    </div>
                  </md-table-cell>
                  <md-table-cell>{{
                    `${round2(averageUsages.ondemand_usage)}${unit}`
                  }}</md-table-cell>
                  <md-table-cell>{{
                    percentage(
                      averageUsages.all_usage,
                      averageUsages.ondemand_usage
                    )
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
          <div v-else class="empty">
            <h3>{{ L('noData') }}</h3>
          </div>
        </md-card-content>
      </md-card>
    </md-content>
    <md-content v-else-if="isEmpty">
      <no-data />
    </md-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api'
import ProjectToolbar from '@/views/billing/ProjectToolbar'
import { GChart } from 'vue-google-charts'
import { round2 } from '@/lib/math'
import { getLastDay } from '@/lib/dateutil'
import moment from 'moment'
import NoData from '@/components/NoData'
import { getUserProjectPermissions } from '@/lib/utils'

export default {
  components: { ProjectToolbar, GChart, NoData },

  data: () => ({
    commitmentType: null,
    region: [],
    project: [],
    regions: [],
    projects: [],
    types: [],
    usageTypes: [
      'active_commitment',
      'utilized_commitment',
      'unutilized_commitment',
      'all_usage',
      'commitment_usage',
      'ondemand_usage',
    ],
    commitments: null,
    selectedAllRegions: true,
    selectedAllProjects: true,
    hover: false,
    isEmpty: false,
    filters: null,
    unit: '',
    activeRegions: '',
    round2,
  }),

  mounted() {
    this.load()
  },

  computed: {
    ...mapState({
      curMonth: (state) => state.curMonth,
      preMonth: (state) => state.preMonth,
      curAccount: (state) => state.curAccount,
      userInfo: (state) => state.userInfo,
    }),

    thisInvoiceMonth() {
      return this.curMonth.replace('-', '')
    },

    lastInvoiceMonth() {
      return this.preMonth.replace('-', '')
    },

    dates() {
      const array = []
      const now = moment().subtract(1, 'days').format('YYYYMMDD')
      const checkMonth = now.substr(0, 6) === this.thisInvoiceMonth
      const endDate = Number(getLastDay(this.thisInvoiceMonth, 'DD'))
      const lastDate = checkMonth ? now.substr(6, 2) : endDate

      for (let i = 1; i <= lastDate; i += 1) {
        const date = i < 10 ? `0${i}` : i
        array.push(`${this.curMonth}-${date}`)
      }

      return array
    },

    monthUsages() {
      if (!this.commitments) return []
      return this.dates.reduce((arr, date) => {
        const item = this.commitments.find((i) => i.date === date)

        const obj = {
          date,
          active_commitment: item ? item.active_commitment : 0,
          utilized_commitment: item ? item.utilized_commitment : 0,
          unutilized_commitment: item ? item.unutilized_commitment : 0,
          all_usage: item ? item.all_usage : 0,
          commitment_usage: item ? item.commitment_usage : 0,
          ondemand_usage: item ? item.ondemand_usage : 0,
        }

        arr.push(obj)
        return arr
      }, [])
    },

    chartData() {
      if (!this.commitments.length) return []

      const array = [
        [
          'Date',
          this.L('commitmentUsage'),
          { type: 'string', role: 'tooltip', p: { html: true } },
          this.L('ondemandUsage'),
          { type: 'string', role: 'tooltip', p: { html: true } },
          this.L('activeCommitment'),
          { type: 'string', role: 'tooltip', p: { html: true } },
        ],
      ]

      this.monthUsages.forEach((item) => {
        const tooltip = `
          <div class="chart-tooltip">
            <div class="tooltip-item">
              <h3>${item.date}</h3>
              <div class="tooltip-content">
                <div class="tooltip-sub-title">${this.L(
                  'commitmentDesc'
                )}(${this.L('averagePerMicrosecond')})</div>
                <div class="tooltip-commitment">
                  <div style="display: flex">
                    <hr class="tooltip-line" />
                    <div>${this.L('activeCommitment')}</div>
                  </div>
                  <div>${round2(item.active_commitment)}${this.unit}</div>
                </div>
                <div class="tooltip-commitment">
                  <div>${this.L('utilizedCommitment')}</div>
                  <div>${round2(item.utilized_commitment)}${this.unit}</div>
                </div>
                <div class="tooltip-commitment">
                  <div>${this.L('unUtilizedCommitment')}</div>
                  <div>${round2(item.unutilized_commitment)}${this.unit}</div>
                </div>
              </div>
              <div class="tooltip-content">
                <div class="tooltip-sub-title">${this.L('usage')}(${this.L(
          'averagePerMicrosecond'
        )})</div>
                <div class="tooltip-commitment">
                  <div>${this.L('allUsage')}</div>
                  <div>${round2(item.all_usage)}${this.unit}</div>
                </div>
                <div class="tooltip-commitment">
                  <div style="display: flex">
                    <div class="tooltip-box" style="background-color: #3366cc;"></div>
                    <div>${this.L('commitmentUsage')}</div>
                  </div>
                  <div>${round2(item.commitment_usage)}${this.unit}</div>
                </div>
                <div class="tooltip-commitment">
                  <div style="display: flex">
                    <div class="tooltip-box" style="background-color: #BDBDBD;"></div>
                    <div>${this.L('ondemandUsage')}</div>
                  </div>
                  <div>${round2(item.ondemand_usage)}${this.unit}</div>
                </div>
              </div>
            </div>
          </div>
        `

        array.push([
          item.date.substr(8),
          item.commitment_usage,
          tooltip,
          item.ondemand_usage,
          tooltip,
          item.active_commitment,
          tooltip,
        ])
      })

      return array
    },

    sumUsages() {
      if (!this.commitments.length) return []
      const obj = {}

      this.usageTypes.forEach((type) => {
        obj[type] = this.sum(this.monthUsages, type) || 0
      })

      return obj
    },

    averageUsages() {
      if (!this.commitments.length) return []
      const obj = {}

      this.usageTypes.forEach((type) => {
        const sum = this.sumUsages[type]
        obj[type] = round2((sum || 0) / this.dates.length)
      })

      return obj
    },

    chartOptions() {
      return {
        legend: { position: 'none' },
        isStacked: true,
        colors: ['#3366cc', '#BDBDBD', '#000000'],
        height: 320,
        chartArea: {
          left: 70,
          right: 50,
          height: 220,
        },
        hAxis: { title: 'Date' },
        fontSize: 13,
        seriesType: 'bars',
        series: { 2: { type: 'line' } },
        lineDashStyle: [5, 5],
        tooltip: { isHtml: true },
      }
    },

    activeCommitment() {
      if (!this.commitments) return 0
      const { length } = this.commitments
      const lastMonth = moment().subtract(1, 'days').format('YYYY-MM')
      let activeCommitment = 0
      let lastDate = this.dates[this.dates.length - 2]

      if (lastMonth !== this.curMonth) {
        lastDate = this.dates[this.dates.length - 1]
      }

      if (!this.commitments.find((u) => u.date === lastDate)) return 0

      if (length === 0) {
        activeCommitment = 0
      } else if (length === 1) {
        const usage = this.commitments[length - 1]
        activeCommitment = usage.active_commitment
      } else {
        const usage = this.commitments[length - 2]
        activeCommitment = usage.active_commitment
      }

      return Math.round(activeCommitment)
    },
  },

  watch: {
    curMonth() {
      this.load()
    },
    curAccount() {
      localStorage.setItem('commitment', null)
      this.load()
    },
    commitments() {
      this.isEmpty = this.commitments === null
    },
  },

  methods: {
    async load() {
      this.init()
      if (!this.curAccount.id) return

      const userProjectPermissions = getUserProjectPermissions(
        this.userInfo.resource,
        this.curAccount
      )
      const filters = await api.usage.commitmentFilters(this.curAccount.id, {
        month: this.thisInvoiceMonth,
        projects: userProjectPermissions,
      })

      if (
        Object.keys(filters).every(
          (key) => filters[key] && filters[key].length > 0
        )
      ) {
        const commitment = JSON.parse(localStorage.getItem('commitment')) || {}
        const { commitmentType, region, project } = commitment

        this.filters = filters
        this.projects = filters.projects
        this.regions = filters.regions
        this.types = filters.types

        this.commitmentType = commitmentType || filters.types[0].type
        this.region = region || filters.regions
        this.project = project || filters.projects.map((i) => i.id)

        await this.getCommitments()
      } else {
        this.isEmpty = true
      }
    },

    init() {
      this.commitments = null
      this.projects = []
      this.regions = []
      this.types = []
      this.activeRegions = []
      this.unit = ''
    },

    getCommitments() {
      const params = {
        month: this.thisInvoiceMonth,
        months: [this.lastInvoiceMonth, this.thisInvoiceMonth],
        projects: this.project || this.projects.map((i) => i.id),
        regions: this.region || this.regions,
        type: this.commitmentType || this.types[0].type,
      }

      this.unit = this.checkType(params.type)
      this.activeRegions = this.selectedAllRegions
        ? this.L('allRegions')
        : params.regions.join(', ')

      return api.usage.commitment(this.curAccount.id, params).then((res) => {
        this.commitments = res
      })
    },

    selectedType(type) {
      switch (type) {
        case 'region':
          if (this.regions.length === this.region.length)
            this.selectedAllRegions = true
          else this.selectedAllRegions = false
          break
        case 'project':
          if (this.projects.length !== this.project.length)
            this.selectedAllProjects = false
          else this.selectedAllProjects = true
          break
        default:
          break
      }
      localStorage.setItem(
        'commitment',
        JSON.stringify({
          region: this.selectedAllRegions ? null : this.region,
          project: this.selectedAllProjects ? null : this.project,
          commitmentType: this.commitmentType,
        })
      )
    },

    selectedAll(type) {
      switch (type) {
        case 'region':
          this.selectedAllRegions = !this.selectedAllRegions
          this.region = this.selectedAllRegions ? this.regions : []
          break
        case 'project':
          this.selectedAllProjects = !this.selectedAllProjects
          this.project = this.selectedAllProjects
            ? this.projects.map((i) => i.id)
            : []
          break
        default:
          break
      }
    },

    sum(item, type) {
      return item.reduce((a, b) => a + (b[type] || 0), 0)
    },

    percentage(total, value) {
      if (total === value) return '100%'
      if (!total || !value) return '0%'
      return `${Math.round((value / total) * 100)}%`
    },

    checkType(type) {
      if (!type) return ''

      let str = ''
      if (type.toLowerCase().includes('cpu')) {
        str = 'vCPU'
      }
      if (
        type.toLowerCase().includes('ram') ||
        type.toLowerCase().includes('ssd')
      ) {
        str = 'GiB'
      }
      if (type.toLowerCase().includes('gpu')) {
        str = 'GPU'
      }
      return ` ${str}`
    },
  },
}
</script>

<style lang="scss" scoped>
.md-content {
  margin: 10px 8px 8px 8px;
}

.google-visualization-tooltip {
  border: none;
}

.hover-tooltip {
  position: absolute;
  z-index: 1;
  width: 330px;
  font-size: 13px;
  display: flex;
  right: 45px;
  > div {
    width: 100%;
  }
  h3,
  .tooltip-sub-title {
    text-align: left;
    margin-top: 10px;
  }
}

::v-deep {
  .md-card {
    margin: 18px 8px;
  }

  .chart-tooltip {
    height: 250px;
    width: 330px;
  }

  .tooltip-box {
    width: 10px;
    height: 10px;
    margin: 4px 5px 0 0;
  }

  .tooltip-item {
    margin: 15px;

    .tooltip-content {
      margin: 10px 0;

      .tooltip-line {
        border-style: none none dotted;
        width: 10px;
        margin-right: 5px;
        height: 5px;
      }

      .tooltip-box {
        margin-top: 6px;
      }

      .tooltip-commitment {
        display: flex;
        justify-content: space-between;

        > div:last-of-type {
          text-align: right;
        }
      }
    }
  }
}

.title {
  margin-top: 25px;
  font-size: large;
}

.strong {
  font-weight: bold;
}

.table {
  margin-top: 40px;
}

.empty {
  margin: 100px;
  text-align: center;
}

.box {
  border: 1px solid #cccccc;
  min-height: 110px;
  margin: 20px 0;
  display: flex;

  .box-item {
    margin: auto;
    width: 33%;
    height: 80%;
    border-right: 1px solid #cccccc;
    text-align: center;

    &:last-of-type {
      border: none;
    }
  }
}
</style>
